import axios from "axios";
import qs from "qs";

export async function ajaxCall(request) {
    const reactAppData = window.program || {}
    const {ajax_url} = reactAppData

    if (ajax_url) {
        try {
            const {data} = await axios.post(ajax_url, qs.stringify(request));

            return data;
        } catch (e) {
            console.log(e);
        }
    }
}
